import React from 'react';
import { Field } from 'formik';
import { Box } from 'lmc-ui-library';
import TextField from 'modules/af_cm_ui_kit/components/TextField/TextField';
import { FIELDS, FIELDS_LABELS } from '../types';
import { FirmDetailsProps } from './types';
import ChangableSelect from 'shared/Profile/ChangeableSelect';
import ChangeableTextField from 'shared/Profile/ChangeableTextField';
import styles from '../profile.module.scss';
import { FirmTypes } from '../CmFirmProfile/types';

const FirmDetails: React.FC<FirmDetailsProps> = ({
  firmType,
  submissionRoutes,
  onChangeClick,
  onCompanyChangeClick,
}) => {
  return (
    <Box title="Firm Details" className={styles.box}>
      <Box.Content>
        <Field
          component={ChangeableTextField}
          name={FIELDS.FIRM_NAME}
          title={FIELDS_LABELS.FIRM_NAME}
          onChangeClick={onCompanyChangeClick(FIELDS.FIRM_NAME_API)}
        />

        <Field component={TextField} name={FIELDS.FCA} title={FIELDS_LABELS.FCA} disabled={true} />

        {firmType === FirmTypes.AR.toString() ? (
          <Field
            component={TextField}
            name={FIELDS.NETWORK_NAME}
            title={FIELDS_LABELS.SUBMISSION_ROUTE}
            disabled={true}
          />
        ) : (
          <Field
            component={ChangableSelect}
            name={FIELDS.SUBMISSION_ROUTE}
            title={FIELDS_LABELS.SUBMISSION_ROUTE}
            options={submissionRoutes}
            onChangeClick={(submissionRouteId: string) => onChangeClick(submissionRouteId)}
            disabled={false}
          />
        )}

        <Field component={TextField} name={FIELDS.REGISTER_DATE} title={FIELDS_LABELS.REGISTER_DATE} disabled={true} />
      </Box.Content>
    </Box>
  );
};

export default FirmDetails;
